module.exports = __webpack_public_path__ + "static/media/logo-digix-roxo.e1c75b4f.svg";